import { css } from "@emotion/react";
import { RefObject, forwardRef, useCallback, useEffect } from "react";
import { FieldInputProps } from "react-final-form";

import { PopperTooltip } from "@livechat/design-system";
import { OpenInNew } from "@livechat/design-system-icons";
import { Button, Icon } from "@livechat/design-system-react-components";

import { InputFieldFullWidthFinalForm } from "components/design-system-adapters/InputField";
import { StackingContextLevel } from "styles/stacking-context-level";

type ITicketDetailsCustomFieldDateProps = FieldInputProps<string, HTMLElement> & {
  handleFormReset?: () => void;
  disabled?: boolean;
  isInputFocused?: boolean;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  input: Record<string, any>;
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  meta: Record<string, any>;
};

// @ts-expect-error TS(2345): Argument of type '(props: any, ref: RefObject<any>... Remove this comment to see the full error message
export default forwardRef(TicketInfoCustomFieldLink);

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
function TicketInfoCustomFieldLink(props: ITicketDetailsCustomFieldDateProps, ref: RefObject<any>) {
  const { input, meta, handleFormReset, disabled, isInputFocused, ...otherProps } = props;
  const { value } = input;

  const handleEscPress = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === "Escape") {
        // @ts-expect-error TS(2722)
        handleFormReset();
        ref.current?.blur();
      }
    },
    [handleFormReset, ref]
  );

  useEffect(() => {
    const { current } = ref;
    current?.addEventListener("keyup", handleEscPress);
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    return () => {
      current?.removeEventListener("keyup", handleEscPress);
    };
  }, [handleEscPress, ref]);

  if (value && !isInputFocused && !meta.error) {
    return (
      <PopperTooltip
        trigger={
          <span>
            <Button
              data-testid="ticket-details-custom-field-link"
              kind="link"
              href={value}
              target="_blank"
              iconPosition="right"
              css={css({ minHeight: "26px" })}
              icon={<Icon source={OpenInNew} />}
            >
              Open link
            </Button>
          </span>
        }
        placement="top"
        zIndex={StackingContextLevel.Tooltip}
      >
        <div
          css={css({
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          })}
        >
          {value}
        </div>
      </PopperTooltip>
    );
  }
  return <InputFieldFullWidthFinalForm {...otherProps} disabled={disabled} input={input} meta={meta} ref={ref} />;
}
